import {useSelector} from 'react-redux';
import {selectMultipleDatesModalFrequency} from '~/SignUpSheets/reducers/sheet/selectors';
import {DatesSelector} from './components/DatesSelector/DatesSelector';
import {DaysSelector} from './components/DaysSelector/DaysSelector';
import {FrequencySelector} from './components/FrequencySelector/FrequencySelector';
import './Repeating.sass';

export const Repeating = () => {
  const frequency = useSelector(selectMultipleDatesModalFrequency);

  return (
    <div className="add-multiple-dates__repeating__form">
      <DatesSelector />
      <FrequencySelector />
      {frequency !== 'monthly' && <DaysSelector />}
    </div>
  );
};
